import(/* webpackMode: "eager", webpackExports: ["AutoRefresh"] */ "/app/apps/web/app/dashboard/AutoRefresh.tsx");
